module.exports = __webpack_public_path__ + "static/media/michaela.744fa5fc.jpeg";